import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'modePa';
const args = {};

export class ModePa extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
